export default "__VITE_ASSET__6RN2fLjM__"